import React, {useState, useEffect} from "react";
import { useSelector, useDispatch } from "react-redux";
import { updateBeneficiarioCapacitacion, 
    insertBeneficiarioCapacitacion,
    deleteBeneficiarioCapacitacion,
    serverMensaje } from '../../redux/reducers/beneficiarios';
import {highlightAll, disableNewlines, pastePlainText } from '../../utils/utils';
import {showToaster} from './BenefShowMesg';
import ContentEditable from 'react-contenteditable';
import Alert, {AlertMessage} from 'calcite-react/Alert';
import Table, {
    TableHeader,
    TableHeaderRow,
    TableHeaderCell,
    TableBody,
    TableRow,
    TableCell
} from 'calcite-react/Table';
import Select from 'calcite-react/Select';
import {MenuItem} from 'calcite-react/Menu';
import Button from 'calcite-react/Button';

import SaveIcon from 'calcite-ui-icons-react/SaveIcon';
import TrashIcon from 'calcite-ui-icons-react/TrashIcon';
import UserPlusIcon from 'calcite-ui-icons-react/UserPlusIcon';

import tipoParentescos from '../../data/parentesco.json';

const BenefCapacitacion = ({capacitacion, beneficiarioId}) => {
    const dispatch = useDispatch();
    const mensaje = useSelector(state => state.beneficiarios.mensaje);
    const users = useSelector(state => state.users);
    // const isEditable = users.user.tipo==='ADMINISTRADOR' ? true : false;
    const isEditable = (users.user.areatrabajo==='ADMINISTRATIVA' || users.user.areatrabajo==='TRABAJO SOCIAL' || users.user.areatrabajo==='COORDINACIÓN' || users.user.areatrabajo==='PSICOLOGÍA' ) ? true : false;
    const [isBtnAddEnable, setIsBtnAddEnable] = useState(false);
    const [error, setError] = useState(null);
    const [CH, updateCH] = useState([...capacitacion]); //Object.assign({}, capacitacion); // Arreglos no Objects

    useEffect(() => {

        if (mensaje.capacitacion && mensaje.capacitacion!=='') {
            const insertCapacitacion = (id, f, v) => {
                if (CH){
                    updateCH(CH.map((itm, index) => {
                        if (itm.id===id){
                            itm[f] = v;
                        }
                        return itm;
                    }));
                    mensaje.capacitacion='';
                    // dispatch(serverMensaje({capacitacion:''}));
                }
            };

            if (typeof mensaje.capacitacion === 'string' && mensaje.capacitacion.toLowerCase().includes('error')){
                showToaster('error', 'Ocurrió un fallo en el servidor', mensaje.capacitacion);
            } 
            else {
                showToaster('success',"Capacitación en el Hogar del Beneficiario", mensaje.capacitacion.split('.')[0]);
                // Update Id for edition
                // Cambiar el id por el que devuelve el servidor o transacción de MySQL
                insertCapacitacion('-1', 'id', String(mensaje.capacitacion.split('.')[1]));
            }
        }

    }, [mensaje.capacitacion, updateCH, CH, dispatch]);
    
    const updateCapacitacion = (id, f, v) => {
        if (CH){
            updateCH(CH.map((itm, index) => {
                if (itm.id===id){
                    itm[f] = v;
                }
                return itm;
            }));
        }
    };

    const updateDataonServer = (id, action, newItem) =>{
        dispatch(serverMensaje({capacitacion:''}));
        switch (action) {
            case 'insert':
                if (parseInt(id)< 0 && newItem){
                    // console.log('insertando nuevo registro: ', newItem);
                    setIsBtnAddEnable(true);
                }
                break;
            case 'save':
                if (id){
                    const reg = CH.filter(itm => itm.id===id);
                    if (reg && reg.length>0){
                        dispatch(insertBeneficiarioCapacitacion( { token: users.user.claveAPI, capacitacion:reg[0]}));
                        setIsBtnAddEnable(false);
                    }
                }
                break;
            case 'remove':
                if (id){
                    const reg = CH.filter(itm => itm.id===id);
                    if (reg && reg.length>0){
                        dispatch(deleteBeneficiarioCapacitacion( { token: users.user.claveAPI, capacitacion:reg[0]}));
                    }
                }
                break;
            default: // update
                // Actualizar solo el registro necesario, para no enviar toda la tabla
                if (id && parseInt(id) > 0){
                    const reg = CH.filter(itm => itm.id===id);
                    if (reg && reg.length>0){
                        dispatch(updateBeneficiarioCapacitacion( { token: users.user.claveAPI, capacitacion:reg[0]}));
                    }
                }
                break;
        }
    }

    const replaceSomeText = (s) =>{
        return s
            .replace(/&nbsp;/g, ' ')
            .replace(/<br>/g, '')
            .replace(/&amp;/g, '&')
            .replace(/&gt;/g, '>')
            .replace(/&lt;/g, '<').trim()
    }

    const validateInput = (f, v, final) => {
        const regex_onlynum = /^[0-9]*$/i; ///[0-9,]|\./;
        // const regex_nombres = /^['`´a-zA-ZÀ-ÿ\u00C0-\u017F\s]+$/;
        let new_val = null;
        let err = null;
        switch (f) {
            case 'nombre':
                new_val = v.substr(0,120);
                if (final)
                    new_val = replaceSomeText(v).substr(0,120);
                break;
            case 'parentesco':
                new_val = v.substr(0,32);
                if (final)
                    new_val = replaceSomeText(v).substr(0,32);
                break;
            case 'entidad':
                new_val = v.substr(0,120);
                if (final)
                    new_val = replaceSomeText(v).substr(0,120);
                break;
            case 'tipo':
                new_val = v.substr(0,120);
                if (final)
                    new_val = replaceSomeText(v).substr(0,120);
                break;
            case 'anio':
                new_val = replaceSomeText(v);
                if (!regex_onlynum.test(new_val)) {
                    err = 'Dígite solo números válidos';
                    new_val = null;
                }
                if (new_val===null) new_val = '';
                break;
            // case 'comentarios':
            //     new_val = replaceSomeText(v); //.substr(0,255);
            //     break;
            default:
                break;
        }
        setError(err);
        return new_val
    }

    const handleParentescoSelectChange = (value, id) => {
        CH['parentesco'] = value;
        updateCapacitacion(id,'parentesco', value );
        updateDataonServer(id);
    };
    
    const handleChange = evt => {
        const [, field, id] = evt.currentTarget.id.split('_');
        const new_val = validateInput(field, evt.target.value, false);
        if(new_val){
            updateCapacitacion(id,field, new_val );
            // console.log("tabla, field, id", tabla, field, id, new_val);
        };

    };
    const handleBlur = evt => {
        const val = evt.currentTarget.innerHTML;
        const [,field, id] = evt.target.id.split('_');
        const new_val = validateInput(field, val, true)
        if(new_val || new_val===''){
            // console.log("tabla, field, id", tabla, field, id, val);
            updateCapacitacion(id,field, new_val );
            updateDataonServer(id);
        };
    };

    const onClickAddCapacitacion = () => {
        const newId = -1;
        const nueva_capacidad = {
            "id": String(newId),
            "beneficiarioId": beneficiarioId,
            "nombre": "",
            "parentesco": "",
            "entidad": "",
            "tipo": "",
            "anio": "",
            // "version": "2020-06-03 10:03:03"
        }
        updateCH([...CH].concat(nueva_capacidad) );
        updateDataonServer(newId, 'insert', nueva_capacidad);
    }
    const onClickSaveCapacitacion = (id) => {
        updateDataonServer(id, 'save');
    }
    const onClickRemoveCapacitacion = (id) => {
        updateCH([...CH].filter(itm => itm.id!==id));
        updateDataonServer(id, 'remove');
    }

    return (
        <div>
            { error && <div style={{color: 'red', width: '100%'}}>
                <Alert red showIcon style={{minWidth: '100%', marginBottom: '10px'}}
                    showCloseLabel 
                    onClose={() => setError(null)}>
                    <AlertMessage>
                        Error:{' '}
                        <strong>{error}</strong>
                    </AlertMessage>
                </Alert>
                </div>
            }
        <div className="itemContainer-table-capacitacion">
        <Table striped>
            <TableHeader>
                <TableHeaderRow>
                    <TableHeaderCell style={{textAlign:'center'}}>Nombre</TableHeaderCell>
                    <TableHeaderCell style={{textAlign:'center'}}>Parentesco</TableHeaderCell>
                    <TableHeaderCell style={{textAlign:'center'}}>Año</TableHeaderCell>
                    <TableHeaderCell style={{textAlign:'center'}}>Entidad o Institución</TableHeaderCell>
                    <TableHeaderCell style={{textAlign:'center'}}>Tipo Capacitación</TableHeaderCell>
                    <TableHeaderCell style={{textAlign:'center'}}>Acción</TableHeaderCell>
                </TableHeaderRow>
            </TableHeader>
            <TableBody>
                {
                    CH.map((ch, index) => (
                        <TableRow key={ch.id}>
                            <TableCell style={{minWidth:'80px'}}>
                                <ContentEditable
                                    id={'capacitacion_nombre_'+ch.id}
                                    html={ch.nombre || ''} // innerHTML of the editable div
                                    className='itemContainer-value-table'
                                    disabled={!isEditable}      // use true to disable editing
                                    onPaste={pastePlainText} // En caso se copie y pegue de otra pagina de internet
                                    onChange={handleChange} // handle innerHTML change
                                    onKeyPress={disableNewlines}  
                                    onFocus={highlightAll}
                                    onBlur={handleBlur}
                                    tagName='div' // Use a custom HTML tag (uses a div by default)
                                />
                            </TableCell>
                            <TableCell style={{maxWidth:'120px'}}>
                                <Select filterable positionFixed disabled={!isEditable} 
                                    id={'capacitacion_parentesco_'+ch.id}
                                    className={'itemContainer-table-selects'}
                                    onChange={(value, item) => handleParentescoSelectChange(value, ch.id)}
                                    selectedValue={ch.parentesco.trim()}
                                >
                                {tipoParentescos.tipo.map(p => {
                                    return (
                                    <MenuItem key={p.id} value={p.name}>
                                        {p.name}
                                    </MenuItem>
                                    )
                                })}
                                </Select>
                            </TableCell>
                            <TableCell style={{minWidth:'40px'}}>
                                <ContentEditable
                                    id={'capacitacion_anio_'+ch.id}
                                    html={ch.anio || ''} // innerHTML of the editable div
                                    className='itemContainer-value-table'
                                    disabled={!isEditable}      // use true to disable editing
                                    onPaste={pastePlainText} // En caso se copie y pegue de otra pagina de internet
                                    onChange={handleChange} // handle innerHTML change
                                    onKeyPress={disableNewlines}  
                                    onFocus={highlightAll}
                                    onBlur={handleBlur}
                                    tagName='div' // Use a custom HTML tag (uses a div by default)
                                />
                            </TableCell>
                            <TableCell style={{minWidth:'140px'}}>
                                <ContentEditable
                                    id={'capacitacion_entidad_'+ch.id}
                                    html={ch.entidad || ''} // innerHTML of the editable div
                                    className='itemContainer-value-table'
                                    disabled={!isEditable}      // use true to disable editing
                                    onPaste={pastePlainText} // En caso se copie y pegue de otra pagina de internet
                                    onChange={handleChange} // handle innerHTML change
                                    onKeyPress={disableNewlines}  
                                    onFocus={highlightAll}
                                    onBlur={handleBlur}
                                    tagName='div' // Use a custom HTML tag (uses a div by default)
                                />
                            </TableCell>
                            <TableCell style={{minWidth:'140px'}}>
                                <ContentEditable
                                    id={'capacitacion_tipo_'+ch.id}
                                    placeholder={'(talleres, cursos, diplomados, etc.)'}
                                    html={ch.tipo || ''} // innerHTML of the editable div
                                    className='itemContainer-value-table'
                                    disabled={!isEditable}      // use true to disable editing
                                    onPaste={pastePlainText} // En caso se copie y pegue de otra pagina de internet
                                    onChange={handleChange} // handle innerHTML change
                                    onKeyPress={disableNewlines}  
                                    onFocus={highlightAll}
                                    onBlur={handleBlur}
                                    tagName='div' // Use a custom HTML tag (uses a div by default)
                                />
                            </TableCell>
                            <TableCell style={{maxWidth:'140px'}}>
                                {
                                    (parseInt(ch.id)< 0)
                                    ?
                                    <Button extraSmall clear iconPosition="before"
                                        disabled={!isEditable} 
                                        id={'capacitacion_guardar_'+ch.id}
                                        // style={{margin: '0 0 0.5rem 0'}}
                                        onClick={(evt) => onClickSaveCapacitacion(ch.id)}
                                        icon={<SaveIcon size={16} />}
                                    >
                                        Guardar
                                    </Button>
                                    :
                                    <Button extraSmall clear iconPosition="before"
                                        disabled={!isEditable} 
                                        id={'capacitacion_eliminar_'+ch.id}
                                        onClick={(evt) => onClickRemoveCapacitacion(ch.id)}
                                        icon={<TrashIcon size={16} />}
                                    >
                                        Eliminar
                                    </Button>
                                }
                            </TableCell>
                        </TableRow>
                    ))
                }
            </TableBody>
        </Table>
        </div>
            <div className="">
                <Button iconPosition="before" 
                    disabled={!isEditable || isBtnAddEnable} 
                    id={'capacitacion_agregar'}
                    onClick={onClickAddCapacitacion}
                    icon={<UserPlusIcon size={16} />}
                >
                    Agregar nuevo capacitación
                </Button>
            </div>

        </div> 
    );
}
   
export default BenefCapacitacion;

